import { gql } from "@apollo/client";

// local schema
export const typeDefs = gql`
  type Pos {
    x: Int!
    y: Int!
  }
`;
